import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  input: {
    "& input[type=number]": {
      "-moz-appearance": "textfield",
    },
    "& input[type=number]::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "& input[type=number]::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
  },
});

const SlotCountForm = ({
  open,
  formValues,
  isDisabled,
  handleClose,
  handleInputChange,
  findDuplicateSlotCount,
  vehicleTypeOptions,
  parkingOptions,
}) => {
  const classes = useStyles();
  return (
    <>
      <Dialog fullWidth open={open} onClose={handleClose}>
        <Box className="flex justify-between">
          <DialogTitle className="text-[#312C41] !text-[16px] !font-semibold">
            {!formValues?.id ? "Create" : "Edit"} Slot Count
          </DialogTitle>

          <CancelRoundedIcon
            onClick={handleClose}
            className="bg-[white] !text-[#344767] !text-[1.7rem] !outline-none p-4 cursor-pointer"
          />
        </Box>

        <DialogContent>
          <Stack spacing={4} paddingLeft={2} paddingRight={2} paddingBottom={2}>
            <Stack direction="row" spacing={2}>
              <FormControl fullWidth size="small">
                <InputLabel size="small" required>
                  Vehicle type
                </InputLabel>
                <Select
                  labelId="Vehicle type"
                  label="Vehicle_type*"
                  name="vehicleType"
                  value={formValues?.vehicleType}
                  onChange={handleInputChange}
                >
                  {vehicleTypeOptions?.map((obj) => {
                    if (obj.deleted === false) {
                      return <MenuItem value={obj.id}>{obj.name}</MenuItem>;
                    } else {
                      return null;
                    }
                  })}
                </Select>
              </FormControl>
              <FormControl fullWidth size="small">
                <InputLabel size="small" required>
                  Parking type
                </InputLabel>
                <Select
                  labelId="Parking type"
                  label="Parking type*"
                  name="parkingType"
                  value={formValues?.parkingType}
                  onChange={handleInputChange}
                >
                  {/* eslint-disable */}
                  {parkingOptions?.map((obj) => {
                    if (obj.deleted === false)
                      return <MenuItem value={obj.id}>{obj.name}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            </Stack>
            <Stack direction="row" spacing={2}>
              <TextField
                required
                fullWidth
                name="currentCount"
                type="number"
                id="outlined-required"
                label="Current Slot Count"
                size="small"
                className={classes.input}
                InputLabelProps={{ shrink: true }}
                value={formValues.currentCount}
                onChange={handleInputChange}
              />
              <TextField
                required
                fullWidth
                name="totalCount"
                type="number"
                id="outlined-required"
                label="Total Slot Count"
                size="small"
                className={classes.input}
                InputLabelProps={{ shrink: true }}
                value={formValues.totalCount}
                onChange={handleInputChange}
              />
            </Stack>
            <Button
              disabled={!isDisabled}
              onClick={findDuplicateSlotCount}
              sx={{
                textTransform: "none",
                background: !isDisabled
                  ? "gray"
                  : "linear-gradient(135deg, #3A416F 0%, #141727 100%)",
                color: "white",
                "&:hover": {},
              }}
            >
              {formValues.id ? "Update" : "Ok"}
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SlotCountForm;
